<template>
    <v-container v-show="loadingWasSuccessful" class="pa-0">
        <div v-if="list_error" class="red--text">
            Beim Laden der Liste ist ein Fehler aufgetreten.<br /><br />Bitte lade sie
            einmal neu!
        </div>
        <div v-else>
            <div v-if="hasSpots">
                <v-list
                    three-line
                    subheader
                    class="text-left"
                    color="rgba(255, 255, 255, 0)">
                    <v-list-item-group
                        v-model="selectedSpotIdInList"
                        @change="checkIntoSpot"
                        :style="{ 'background-color': theme.backgroundColor}">
                        <template v-for="(item, index) in allActiveVisibleSpots">
                            <v-list-item v-if="item"
                                         :key="item.id"
                                         :value="item.id"
                                         :ripple="false"
                                         :id="`spot_${item.id}`">

                                <!-- Tile mode -->
                                <template v-if="isTileMode">
                                    <v-card class="my-1" width="100%" rounded="xl">
                                        <!-- image -->
                                        <v-img
                                            cover
                                            :class="{'max-height-959': $vuetify.breakpoint.width > 959}"
                                            class="white--text align-end task-images"
                                            :aspect-ratio="16 / 9"
                                            :src="firstGalleryImage(item)"
                                            :gradient="getGradientOpacity(0.2)">
                                            <!-- overlay -->
                                            <v-overlay
                                                :absolute="true"
                                                :opacity="1"
                                                :value="taskOverlay(item)"
                                                :color="taskOverlayColor(item)"
                                            ></v-overlay>

                                            <!-- Title-->
                                            <v-app-bar
                                                flat
                                                color="rgba(0, 0, 0, 0)"
                                                style="top: 0; position: absolute"
                                                class="pt-3">
                                                <v-toolbar-title class="white--text pl-1 text-shadow">
                                                    <h3 class="title">{{ getSpotTitle(item) }}</h3>
                                                    <div v-if="settingsShowIntNr" class="body-1">
                                                        {{ getLabelIntNr(item) }}
                                                    </div>
                                                    <div v-else class="pb-3"></div>
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-avatar tile
                                                ><v-img :src="getSpotIconUrl(item.tbild, spotIsInactive(item))"></v-img
                                                ></v-avatar>
                                            </v-app-bar>
                                            <v-card-title class="justify-start align-start"></v-card-title>
                                        </v-img>

                                        <!-- Meta tags -->
                                        <div class="meta-tags">
                                            <v-card flat class="pa-1" :style="{'background-color': theme.headerFooterColor, 'border-bottom-right-radius':'20px', 'border-bottom-left-radius':'20px'}">
                                                <v-row no-gutters :color="theme.headerFooterColor" :style="{ 'background-color': theme.headerFooterColor}" justify="start" align="center">
                                                    <v-col v-if="!hideTaskPoints || !settingsGpsDisabled" cols="8" align="start">
                                                        <span v-if="!hideTaskPoints" class="mr-3">
                                                            <v-icon :color="theme.footerIconColor">mdi-star-circle</v-icon>
                                                            <span class="caption"  v-bind:style="{'color':theme.footerIconColor}">
                                                                {{ item.points }}
                                                            </span>
                                                        </span>
                                                        <span v-if="!settingsGpsDisabled">
                                                            <v-icon :color="theme.footerIconColor">mdi-map-marker-distance</v-icon>
                                                            <span class="caption" v-bind:style="{'color':theme.footerIconColor}">
                                                                {{ distanceLabel(item) }}
                                                            </span>
                                                        </span>
                                                    </v-col>
<!--                                                    <v-col cols="7">-->
<!--                                                        <span v-if="item.raetsel && !_.isEmpty(item.raetsel.categories)">-->
<!--                                                            <v-icon :color="theme.footerIconColor">mdi-tag-multiple</v-icon>-->
<!--                                                            <span class="caption" v-bind:style="{'color':theme.footerIconColor}">-->
<!--                                                                {{item.raetsel.categories.join(',') }}-->
<!--                                                            </span>-->
<!--                                                        </span>-->
<!--                                                    </v-col>-->
                                                    <v-col :cols="(hideTaskPoints && settingsGpsDisabled) ? 12 : 4" align="end" style="text-align: end">
                                                        <v-icon
                                                            v-if="spotIsSolved(item) || spotIsFailed(item)"
                                                            :color="taskOverlayColor(item, 1)"
                                                            x-large
                                                            class=""
                                                        >{{ taskStatusIcon(item) }}</v-icon>
                                                        <v-icon
                                                            v-else
                                                            :color="taskArrowColor(item, settingsGpsDisabled)"
                                                            x-large
                                                            class=""
                                                        >mdi-chevron-right</v-icon>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </template>

                                <!-- List mode -->
                                <template v-else>
                                    <v-list-item-avatar tile v-if="item.tbild">
                                        <v-img :src="getSpotIconUrl(item.tbild, spotIsInactive(item))"></v-img>
                                    </v-list-item-avatar>

                                    <!-- Solved/Failed icon-->
                                    <!--<div v-if="taskOverlay(item)" class="mr-4"><v-icon :color="taskOverlayColor(item,1)">{{taskStatusIcon(item)}}</v-icon></div>-->

                                    <v-list-item-content :style="{'color':theme.textColor}">
                                        <v-list-item-title>{{getSpotTitle(item) }}</v-list-item-title>
                                        <v-list-item-subtitle
                                            v-if="settingsShowIntNr"
                                            class="caption"
                                            :style="{'color':theme.textColor}">
                                            {{ getLabelIntNr(item) }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle :style="{'color':theme.textColor}">
                                            <!-- Meta tags -->
                                            <span v-if="!hideTaskPoints" class="mr-3">
                                                <v-icon small :color="theme.textColor">mdi-star-circle</v-icon>
                                                <span class="caption" :style="{'color':theme.textColor}">{{ item.points }}</span>
                                            </span>
                                            <span v-if="!settingsGpsDisabled" class="mr-3">
                                                <v-icon small :color="theme.textColor">mdi-map-marker-distance</v-icon>
                                                <span class="caption" :style="{'color':theme.textColor}">{{ distanceLabel(item) }}</span>
                                            </span>
<!--                                            <span v-if="item.raetsel && !_.isEmpty(item.raetsel.categories)">-->
<!--                                                <v-icon small :color="theme.textColor">mdi-tag-multiple</v-icon>-->
<!--                                                <span class="caption">{{item.raetsel.categories.join(',') }}</span>-->
<!--                                            </span>-->
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon
                                            v-if="spotIsSolved(item) || spotIsFailed(item)"
                                            :color="taskOverlayColor(item, 1)"
                                            x-large
                                            class="pt-2"
                                        >{{ taskStatusIcon(item) }}</v-icon>
                                        <v-icon
                                            v-else
                                            :color="taskArrowColor(item, settingsGpsDisabled)"
                                            x-large
                                            class="pt-2">mdi-chevron-right</v-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>

                            <v-divider
                                color="#ececec"
                                v-if="isListMode && index < allActiveVisibleSpots.length - 1"
                                :key="index"
                            ></v-divider>
                        </template>
                    </v-list-item-group>
                </v-list>
            </div>
            <div v-else class="pt-10 px-4">
                {{ $t('task_list_error', { tasksname: this.labelTasks }) }}
            </div>
        </div>
    </v-container>
</template>

<script>
import CONFIG from "../../constants/config";
import {settingsMixin} from "../../utils/settings-mixin";
import {layoutMixin} from "../../utils/layout-mixin";
import {spotMixin} from "../../utils/spot-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {imageMixin} from "../../utils/image-mixin";

export default {
    mixins: [settingsMixin, eventMixin, layoutMixin, spotMixin, imageMixin],
    components: {},
    props: {
        eventId: {},
        mode: {
            type: Number,
            default: 0,
        },
        sortOrder: {
            type: Object,
            default: () => ({ order: 'asc', option: 'byNumber' }),
        },
        spot: {},
    },
    data: () => ({
        selectedSpotIdInList: undefined,
    }),
    watch: {
        /* Init data on creation and on update */
        eventId: {
            handler() {
                this.$nextTick(() => {
                    //this.getSpotListIfEmpty(); is set by eventLayout!!!
                });
            },
            immediate: true,
        },
        sortOrder: {
            handler(val) {
                this.setSortOrder(val);
            },
            immediate: true,
        },
        // not deep: a nested change (distance on every GPS fix, trials, hints) must not re-select
        // the item after clearSelect(), otherwise the next tap only toggles the selection off
        spot: {
            handler(val) {
                this.selectedSpotIdInList = val ? val.id : undefined;
            },
            immediate: true,
        },
    },
    computed: {
        isListMode() {
            return this.mode == CONFIG.SPOT_LIST_MODE_LIST;
        },
        isTileMode() {
            return this.mode == CONFIG.SPOT_LIST_MODE_TILE;
        },
        hideTaskPoints() {
            return this.parseBoolean(CONFIG.HIDE_TASK_POINTS, false);
        },
        loadingWasSuccessful() {
            return !this.isLoadingSpots && this.hasSpots;
        },
    },
    methods: {
        centerSpot(spotId) {
            if (spotId) {
                let el = document.getElementById(`spot_${spotId}`);
                el.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
        },
        getLabelIntNr(item) {
            return `${this.labelTask} #${item.waintnr}`;
        },

        clearSelect() {
            this.selectedSpotIdInList = undefined;
        },
        checkIntoSpot(spotId) {
            if (spotId) {
                this.selectedSpotIdInList = spotId;
                this.$emit('select', spotId);
            }
        },
        galleryImages(item) {
            return this.getGalleryImages(item);
        },
        // first image only, like the native app: a leading video or audio must not become the tile cover
        firstGalleryImage(item) {
            let img = this._.find(this.galleryImages(item), (url) => this.isImage(url));
            return this._.isEmpty(img) ?
                ( this.selectedEvent.bg_task ?
                        this.getEventDefaultTaskImage(this.selectedEvent.bg_task)
                        : this.defaultImage
                )
                : img;
        },
        taskOverlay(item) {
            return item
                ? this.spotIsInactive(item) ||
                this.spotIsSolved(item) ||
                this.spotIsFailed(item)
                : false;
        },

        next() {
            let spot = this.getSpotSibling(
                this.allActiveVisibleSpots,
                this.selectedSpotIdInList,
                1,
            );

            if (!this._.isEmpty(spot)) {
                this.checkIntoSpot(spot.id);
            }
        },
        prev() {
            let spot = this.getSpotSibling(
                this.allActiveVisibleSpots,
                this.selectedSpotIdInList,
                -1,
            );
            if (!this._.isEmpty(spot)) {
                this.checkIntoSpot(spot.id);
            }
        },
        distanceToCurrentPosition(km){
            return km>1 ? km.toFixed(1)+' km' : (km*1000).toFixed(0)+' m';
        },
        // null distance means no position yet (permission denied, no fix); 0 is a valid distance
        distanceLabel(item){
            return item.distanceToCurrentPosition != null
                ? this.distanceToCurrentPosition(item.distanceToCurrentPosition)
                : this.$t('gpsNoSignal');
        }
    },
};
</script>

<style scoped>
/* remove corner in tile meta */
.v-sheet.v-card {
    border-radius: 0;
}
/* reduce padding in tile items */
.v-list-item {
    padding: 0 8px;
}
.text-shadow {
    text-shadow: 0px 0px 3px rgba(29, 29, 29, 0.67);
}
.max-height-959 {
    max-height: 160px;
}
</style>